import _isInteger from 'lodash/isInteger';
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import _isEmpty from 'lodash/isEmpty';
import _isBoolean from 'lodash/isBoolean';

export const isRequired = val => {
  val = typeof val === 'string' ? val.trim() : val;
  return _isBoolean(val) || !_isEmpty(val) || _isNumber(val);
};

export const isOneOf = (val, { subject = [] } = {}) => {
  return subject.includes(val);
};

/**
 * @param {Object} options
 * @param {Number} options.min Min value validated integer can take
 * @param {Number} options.max Max value validated integer can take
 * @param {(value) => Number} options.cast Cast input value to desired type
 *  Defaults to `Number`
 */
export const isInteger = ({
  min = Number.MIN_SAFE_INTEGER,
  max = Number.MAX_SAFE_INTEGER,
  cast = Number,
}) => val => {
  const castedVal = cast(val);
  const valid = val !== '' && _isInteger(castedVal) && castedVal >= min && castedVal <= max;

  return valid;
};

/**
 * `min` and `max` params only work on browsers that have `BigInt` implementation
 *
 * @param {Object} options
 * @param {Number} options.min Min value validated integer can take
 * @param {Number} options.max Max value validated integer can take
 */
export const isBigInteger = ({ min = null, max = null }) => val => {
  const isValidIntegerString = /^[-]?[1-9]\d*$/.test(val) || val === 0 || val === '0';
  const isBigIntDefined = !!window.BigInt;

  let valid = val !== '' && isValidIntegerString;

  if (isBigIntDefined) {
    try {
      const bigIntValue = window.BigInt(val);
      valid =
        valid &&
        (min !== null ? bigIntValue >= min : true) &&
        (max !== null ? bigIntValue <= max : true);
    } catch (error) {
      // Conversion error, do nothing
    }
  }

  return valid;
};

/**
 * @param {Object} options
 * @param {Number} options.min Min value validated String can take
 * @param {Number} options.max Max value validated String can take
 * @param {(value) => String} options.cast Cast input value to desired type
 *  Defaults to `String`
 */
export const isString = ({ min = 0, max = Number.MAX_VALUE, cast = String }) => val => {
  const castedVal = cast(val);
  const valid =
    val !== '' && _isString(castedVal) && castedVal.length >= min && castedVal.length <= max;

  return valid;
};
